import { Domain } from "../../config";
const BASE_URL = `https://api.vadvisor.${Domain}`;

export const VadvisorApi = {
  ConfigAlgos: () => `${BASE_URL}/v1/config/algos`,
  SettingsDuidBidTypesByAlgoId: ({ algoId }) =>
    `${BASE_URL}/v1/settings/algos_duid_bid_types/${algoId}`,
  //SOLVES
  GetSolvesCompositeResult: ({ bidSettlementDateStr }) =>
    `${BASE_URL}/v1/solves/result_composite/${bidSettlementDateStr}`,
  GetSolveResultById: ({ bidSettlementDateStr, solveId }) =>
    `${BASE_URL}/v1/solves/result/${bidSettlementDateStr}/${solveId}`,
  GetSolveBidSets: ({ bidSettlementDate }) =>
    `${BASE_URL}/v1/solves/bid_set/${bidSettlementDate}`,
  GetSolveBidsBySolveId: ({ solveId, bidSettlementDate }) => `
  ${BASE_URL}/v1/solves/bids/${bidSettlementDate}/${solveId}`
};
